export const I18N_PREFIX =
  'modules:streamer:sections:data:modes:boards:preview';

export const KEYS_SHOWN_ON_MOUNT = 4;
export const CARD_MIN_WIDTH = 300;
